import React, {useState, useEffect, useRef} from "react";
import "./AiAgent1.css";
import AiLogo from "../././assets/images/Ai_user_icon.png";
import AiGif from "../../src/assets/images/Siri.gif";
import {suggestions as originalSuggestions} from "./Suggestions";
import {FaThumbsUp, FaThumbsDown, FaStar} from "react-icons/fa";
import aiLogoModal from "../../src/assets/images/aiiiiii.png";
import suggestionIcon from "../../src/assets/images/suggestion.png";
import issuesIcon from "../../src/assets/images/Issues.png";
import sendaiiimg from "../../src/assets/images/sendaiiii.png";
import likeaibtn from "../../src/assets/images/vecteezy_happ.png";
import {TypeAnimation} from "react-type-animation";
import ratesmile1 from "../../src/assets/images/excellent-reaction1.gif";
import ratesmile2 from "../../src/assets/images/excellent-reaction2.gif";
import ratesmile3 from "../../src/assets/images/excellent-reaction3.gif";
import ratesmile4 from "../../src/assets/images/excellent-reaction4.gif";
import ratesmile5 from "../../src/assets/images/excellent-reaction5.gif";
import newtabicon from "../../src/assets/images/new-page.png";
import Tooltip from "@mui/material/Tooltip";
import {calculateDateDifference, generateNewUserId, REDBOT_ISSUES, REGISTRARS, shuffleArray} from "./const";
import {apiBotMessage, apiClient, apiProblemType, apiRTA, apiStoreArn, apiInsertMessage, apiInvestmentDate, apiFileCall, apiFolio, getAiAgentApiUrl,   chatClose,} from "./api";

const AiAgent1 = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [dateInputValue, setDateInputValue] = useState("");
    const [transcript, setTranscript] = useState("");
    const [error, setError] = useState("");
    const [status, setStatus] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const tokenRef = useRef(null);
    const [promptSuggestions, setPromptSuggestions] = useState([]);
    const [isUserAtBottom, setIsUserAtBottom] = useState(true);
    const chatSectionRef = useRef(null);
    const userIdRef = useRef(null);
    const accumulatedTranscriptRef = useRef("");
    const [scrollSignal, setScrollSignal] = useState(0);
    const [redbotContext, setRedbotContext] = useState({});

    // State for Redbot input selection
    const [isPanMode, setIsPanMode] = useState(false);
    const [isFolioMode, setIsFolioMode] = useState(false);
    const [isDateInputMode, setIsDateInputMode] = useState(false);

    const [arn, setArn] = useState(null);
    const [isAsm, setIsAsm] = useState(1);

    const [botSession, setBotSession] = useState(null);

    // State for arn_list
    const [arnList, setArnList] = useState([]);
    const [arnLoading, setArnLoading] = useState(false);
    const [arnError, setArnError] = useState("");

    // State for Feedback Modal
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [feedbackSubmitting, setFeedbackSubmitting] = useState(false);

    // AI Agent URL
    const AI_AGENT_URL = getAiAgentApiUrl();

    // Placeholder for Redbot input based on condition
    const inputPlaceholder = isPanMode  ? "Enter PAN Number Here..."  : isFolioMode  ? "Enter folio number here..."  : "Type your message...";

    // Wealth Elite Base URL 
    const baseUrl = process.env.REACT_APP_ENVIRONMENT === "dev"  ? process.env.REACT_APP_WEALTH_ELITE_DEV : process.env.
    REACT_APP_WEALTH_ELITE_LIVE;

    // Resets all special input mode states to their default (false) and clears the main text input field
    const resetInputModes = () => {
        setIsDateInputMode(false);
        setIsPanMode(false);
        setIsFolioMode(false);
        setInputValue("");
    };
    
    // Sends a question and its corresponding answer to a add-chat api to be stored.This function is used to maintain a history 
    const addChatToHistory = async (question, answer) => {
        const currentToken = tokenRef.current;
        if (!currentToken || !question || !answer) {
            console.error("Missing token, question, or answer for addChatToHistory.");
            return;
        }

        try {
            const payload = {
                question,
                answer,
                flag: "history",
            };

            const response = await fetch(`${AI_AGENT_URL}/rag/add-chat`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${currentToken}`,
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.error("Failed to add Redbot interaction to history:", errorData.message || response.statusText);
            }
        } catch (error) {
            console.error("Error in addChatToHistory:", error);
        }
    };

    // const handleNewChatClick = () => {
    //     resetInputModes();
    //     setMessages((prev) => [
    //         ...prev,
    //         {
    //             id: `system-${Date.now()}`,
    //             type: "system",
    //             content: "─── New Chat Started ───",
    //         },
    //     ]);
    //     setScrollSignal((p) => p + 1);
    // };
    
    // On initial component render, this effect shuffles and selects three prompt suggestions to display.
    useEffect(() => {
        setPromptSuggestions(shuffleArray(originalSuggestions).slice(0, 3));
    }, []);

    // On initial component render, this effect generates a user ID if one doesn't exist and retrieves the auth token from local storage.
    useEffect(() => {
        if (!userIdRef.current) generateNewUserId(userIdRef);
        const storedToken = localStorage.getItem("authTokenAi");
        if (storedToken) tokenRef.current = storedToken;
    }, []);

    // This effect fetches the user's recent conversation history when the component mounts
    useEffect(() => {
    const fetchConversations = async () => {
    try {
        const auth = localStorage.getItem("authTokenAi");
        if (!auth || !AI_AGENT_URL) return;
        const res = await fetch(`${AI_AGENT_URL}/report/session-conversations?limit=10`, {
            headers: {
                Authorization: `Bearer ${auth}`,
                "Content-Type": "application/json",
            },
        });
        if (res.status === 401) return;
        const data = await res.json();

        if (data.success && data.data) {
            if (data.data.arn) {
                setArn(data.data.arn);
                setIsAsm(data.data.isAsm);
            }
            if (Array.isArray(data.data.conversations)) {
                const history = [];
                const conversations = [...data.data.conversations].reverse();
                conversations.forEach((conv) => {
                    history.push({
                        id: conv._id + "-q",
                        type: "user",
                        content: conv.question.replace(/<br\s*\/?>/gi, "\n")
                    });

                    // Check if the 'flag' property exists. If it does, feedback is disabled.
                    const showFeedback = !conv.flag;

                    const liked = showFeedback ? conv.status === 1 : false;
                    const disliked = showFeedback ? conv.status === 0 : false;
                    const feedbackGiven = liked || disliked;
                    
                    history.push({
                        id: conv._id + "-a",
                        type: "other",
                        content: conv.answer.replace(/<br\s*\/?>/gi, "\n"),
                        shouldAnimate: false,
                        animationDone: true,
                        // Conditionally set backendMessageId to control feedback UI visibility
                        backendMessageId: showFeedback ? conv.message_id : null,
                        liked,
                        disliked,
                        feedbackGiven,
                        likeDislikeId: showFeedback ? (conv.like_dislike_id || null) : null,
                    });
                });
                if (history.length) setMessages((prev) => [...prev, ...history]);
            }
        }
    } catch (err) {
        console.error("Error fetching conversations:", err);
    }
    };
    fetchConversations();
    }, [AI_AGENT_URL]);

    // Sends a user's question to the RAG API, displays a loading indicator, and returns the backend's answer.
    const callRAGAPI = async (question) => {
        try {
            setStatus("");
            const loadingId = Date.now() + "-loading";
            setMessages((prev) => [
                ...prev,
                {
                    id: loadingId,
                    type: "other",
                    content: "",
                    isLoading: true,
                    shouldAnimate: false,
                    animationDone: false,
                },
            ]);
            setScrollSignal((prev) => prev + 1);
            const currentToken = tokenRef.current;
            if (!currentToken) throw new Error("Authentication token is missing.");

            const response = await fetch(`${AI_AGENT_URL}/rag/ask`, {
                method: "POST",
                headers: {"Content-Type": "application/json", Authorization: `Bearer ${currentToken}`},
                body: JSON.stringify({question}),
            });

            setMessages((prev) => prev.filter((msg) => msg.id !== loadingId));
            if (response.status === 401 || tokenRef.current === null) {
                window.location.href = "/unauthorised";
                return {answer: "Unauthorized", message_id: null};
            }
            const data = await response.json();
            const answer = data?.data?.answer || "Unexpected response from backend.";
            const messageId = data?.data?.message_id;
            return {answer, message_id: messageId};
        } catch (error) {
            setMessages((prev) => prev.filter((msg) => !msg.isLoading));
            console.error("RAG API Error:", error);
            return {answer: `Error: ${error.message || "Something went wrong."}`, message_id: null};
        }
    };

    // A callback function that runs after a message's typing animation finishes,updating the message's state and resetting the global typing indicator.
    const handleAnimationEnd = (messageId) => {
        setMessages((prevMessages) =>
            prevMessages.map((msg) => (msg.id === messageId ? {...msg, animationDone: true} : msg))
        );
        setIsTyping(false);
        setScrollSignal((prev) => prev + 1);
    };

    // Processes a user-submitted PAN number, interacts with the backend, and updates the chat
    const handlePanSubmission = async (panNumber) => {
        const newUserMessageId = Date.now();
        setMessages((prev) => [...prev, {id: newUserMessageId, type: "user", content: panNumber}]);
        setInputValue("");
        setIsProcessing(true);
        setScrollSignal((p) => p + 1);

        try {
            const chatDetails = {
                arn_id: arn,
                chat_date: botSession?.chat_date || new Date().toISOString().split("T")[0],
                chat_id: botSession?.chat_id || (arn ? `${arn}_${Date.now()}` : "Undefined"),
            };

            await apiInsertMessage({
                ...chatDetails,
                client_message: panNumber,
                source: 2,
                option_value: panNumber,
                chat_stage: 3,
            });

            const {data: clientResponse} = await apiClient({...chatDetails, client_message: panNumber, amc: undefined});
            const botResponseMsg = clientResponse.msg || "An unexpected response was received. Please try again.";
            
            // Save to history
            addChatToHistory(`Client Not Found - PAN: ${panNumber}`, botResponseMsg);

            await apiInsertMessage({
                ...chatDetails,
                client_message: botResponseMsg,
                source: 1,
                chat_stage: 3,
            });

            if (clientResponse.status === 1) {
                if (arn) {
                    await chatClose({
                        arn_id: arn,
                        chat_date: chatDetails.chat_date,
                        chat_id: chatDetails.chat_id,
                        client_message: '"close"',
                    });
                }
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        type: "other",
                        content: botResponseMsg,
                        shouldAnimate: true,
                        animationDone: false,
                    },
                ]);
                setIsTyping(true);
                setIsPanMode(false);
            } else if (clientResponse.status === 3) {
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        type: "other",
                        content: botResponseMsg,
                        shouldAnimate: true,
                        animationDone: false,
                    },
                ]);
                setIsTyping(true);
            } else {
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        type: "other",
                        content: botResponseMsg,
                        shouldAnimate: true,
                        animationDone: false,
                    },
                ]);
                setIsTyping(true);
                setIsPanMode(false);
            }
        } catch (e) {
            const errorMessage = "Error validating PAN.";
            addChatToHistory(`Client Not Found - PAN: ${panNumber}`, errorMessage);
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: errorMessage,
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
        } finally {
            setIsProcessing(false);
            setScrollSignal((p) => p + 1);
        }
    };

    //Redirects the user to the chat history page in a new tab after a short delay
    const redirectToHistory = () => {
        setTimeout(() => {
            window.open(
                `${baseUrl}/UserManager/support/chat-bot-history`,
                "_blank" // open in new tab
            );
        }, 5000);
    };

    // Processes a user-submitted folio number, communicates with the backend, and updates the chat
    const handleFolioSubmission = async (folioNumber) => {
        const newUserMessageId = Date.now();
        setMessages((prev) => [...prev, {id: newUserMessageId, type: "user", content: folioNumber}]);
        setInputValue("");
        setIsProcessing(true);
        setScrollSignal((p) => p + 1);

        try {
            const chatDetails = {
                arn_id: arn,
                chat_date: botSession?.chat_date || new Date().toISOString().split("T")[0],
                chat_id: botSession?.chat_id || (arn ? `${arn}_${Date.now()}` : "Undefined"),
            };

            const {data: folioResponse} = await apiFolio({...chatDetails, client_message: folioNumber, amc: undefined});

            if (arn) {
                await chatClose({
                    arn_id: arn,
                    chat_date: chatDetails.chat_date,
                    chat_id: chatDetails.chat_id,
                    client_message: '"close"',
                });
            }

            const messageToShow = folioResponse?.response_msg || folioResponse?.msg || "Folio number processed.";
            // Save to history
            const questionForHistory = `${redbotContext.issue || "Folio Query"} - Folio: ${folioNumber}`;
            addChatToHistory(questionForHistory, messageToShow);

            setMessages((prev) => [
                ...prev,
                {id: Date.now(), type: "other", content: messageToShow, shouldAnimate: true, animationDone: false},
            ]);
            setIsTyping(true);

            // Redirect if status === 1 (flow complete)
            if (folioResponse?.status === 1) {
                setTimeout(() => {
                    redirectToHistory();
                }, 600); // brief delay to let the message animate
            }

            if (folioResponse.status !== 3) {
                setIsFolioMode(false);
            }
        } catch (e) {
            const errorMessage = "An error occurred while validating the folio number.";
            const questionForHistory = `${redbotContext.issue || "Folio Query"} - Folio: ${folioNumber}`;
            addChatToHistory(questionForHistory, errorMessage);

            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: "An error occurred while validating the folio number.",
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
            setIsFolioMode(false);
        } finally {
            setIsProcessing(false);
            setScrollSignal((p) => p + 1);
        }
    };

    // general RAG API based on the current input mode
    const sendMessage = async (messageText = null) => {
        const textToSend = messageText || inputValue;
        if (!textToSend.trim()) return;

        // Determine if the current input is a general question, not specific data
        const isLikelyGeneralQuery = textToSend.includes(" ");

        // If the bot is in a special mode but the user types a general question, reset the mode.
        if ((isFolioMode || isPanMode) && isLikelyGeneralQuery) {
            resetInputModes();
        }
        // After a potential reset, re-evaluate the mode for the submission logic.
        else if (isFolioMode) {
            await handleFolioSubmission(textToSend.trim());
            return;
        } else if (isPanMode) {
            await handlePanSubmission(textToSend.trim());
            return;
        }

        // This block will now correctly handle general queries, even if a special mode was just exited.
        const newMessageId = Date.now();
        setMessages((prev) => [...prev, {id: newMessageId, type: "user", content: textToSend}]);
        setScrollSignal((prev) => prev + 1);
        setInputValue("");
        setTranscript("");
        accumulatedTranscriptRef.current = "";
        setIsProcessing(true);

        try {
            const {answer, message_id: backendMessageId} = await callRAGAPI(textToSend);
            const aiMessageId = Date.now() + 1;
            setMessages((prev) => [
                ...prev,
                {
                    id: aiMessageId,
                    type: "other",
                    content: answer,
                    shouldAnimate: true,
                    animationDone: false,
                    backendMessageId: backendMessageId,
                },
            ]);
            setScrollSignal((prev) => prev + 1);
            setStatus("");
            setIsProcessing(false);
            setIsTyping(true);
        } catch (err) {
            const errorResponse = {
                id: Date.now() + 1,
                type: "other",
                content: "I encountered an error processing your request. Please try again.",
                shouldAnimate: false,
                animationDone: true,
            };
            setMessages((prev) => [...prev, errorResponse]);
            setScrollSignal((prev) => prev + 1);
            setIsProcessing(false);
            setStatus("");
        }
    };

    // Triggers the sendMessage function when the user presses the 'Enter' key, but only if the app is not already busy processing or typing
    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !isProcessing && !isTyping) sendMessage();
    };

    // Scrolls the chat window to the bottom whenever a new message is added or needs visibility
    useEffect(() => {
        if (chatSectionRef.current) {
            setTimeout(() => {
                chatSectionRef.current.scrollTop = chatSectionRef.current.scrollHeight;
            }, 0);
        }
    }, [scrollSignal]);

    // Sending the feedback to the backend
    const handleFeedback = async (messageId, type) => {
        const index = messages.findIndex((msg) => msg.id === messageId);
        if (index === -1) return;
        const message = messages[index];
        const currentToken = tokenRef.current;
        const backendMessageId = message.backendMessageId;
        const previousUserMsg = [...messages]
        .slice(0, index)
        .reverse()
        .find((msg) => msg.type === "user");
        const ratingValue = type === "like" ? 1 : 0;
        const payload = {
            question: previousUserMsg?.content || "",
            answer: message.content,
            status: ratingValue,
            message_id: backendMessageId,
        };
        try {
            setMessages((prevMessages) => {
                const newMessages = [...prevMessages];
                newMessages[index] = {
                    ...newMessages[index],
                    liked: type === "like",
                    disliked: type === "dislike",
                    feedbackGiven: true,
                    likeDislikeId: null,
                };
                return newMessages;
            });
            const endpoint = `${AI_AGENT_URL}/like-dislike`;
            const response = await fetch(endpoint, {
                method: "POST",
                headers: {"Content-Type": "application/json", Authorization: `Bearer ${currentToken}`},
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (result.success && result.data && result.data.id) {
                setMessages((prevMessages) => {
                    const newMessages = [...prevMessages];
                    newMessages[index] = {...newMessages[index], likeDislikeId: result.data.id};
                    return newMessages;
                });
            }
        } catch (err) {
            setMessages((prevMessages) => {
                const newMessages = [...prevMessages];
                if (newMessages[index]) {
                    newMessages[index] = {
                        ...newMessages[index],
                        liked: message.liked || false,
                        disliked: message.disliked || false,
                        feedbackGiven: message.feedbackGiven || false,
                        likeDislikeId: message.likeDislikeId || null,
                    };
                }
                return newMessages;
            });
        }
    };

    //Reverts a previously given 'like' or 'dislike' feedback
    const handleUndoFeedback = async (messageId) => {
        const index = messages.findIndex((msg) => msg.id === messageId);
        if (index === -1) return;

        const message = messages[index];
        const currentToken = tokenRef.current;
        const backendMessageId = message.backendMessageId;
        const originalLiked = message.liked;
        const originalDisliked = message.disliked;
        const originalFeedbackGiven = message.feedbackGiven;
        const originalLikeDislikeId = message.likeDislikeId;

        try {
            setMessages((prevMessages) => {
                const newMessages = [...prevMessages];
                newMessages[index] = {
                    ...newMessages[index],
                    liked: false,
                    disliked: false,
                    feedbackGiven: false,
                    likeDislikeId: null,
                };
                return newMessages;
            });
            const response = await fetch(`${AI_AGENT_URL}/like-dislike/undo`, {
                method: "POST",
                headers: {"Content-Type": "application/json", Authorization: `Bearer ${currentToken}`},
                body: JSON.stringify({message_id: backendMessageId}),
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        } catch (err) {
            setMessages((prevMessages) => {
                const newMessages = [...prevMessages];
                if (newMessages[index]) {
                    newMessages[index] = {
                        ...newMessages[index],
                        liked: originalLiked,
                        disliked: originalDisliked,
                        feedbackGiven: originalFeedbackGiven,
                        likeDislikeId: originalLikeDislikeId,
                    };
                }
                return newMessages;
            });
        }
    };

    // Attaches a scroll listener to the chat container to track if the user is at the bottom
    useEffect(() => {
        const handleScroll = () => {
            if (!chatSectionRef.current) return;
            const {scrollTop, scrollHeight, clientHeight} = chatSectionRef.current;
            const atBottom = scrollHeight - scrollTop <= clientHeight + 5;
            setIsUserAtBottom(atBottom);
        };
        const chatEl = chatSectionRef.current;
        if (chatEl) chatEl.addEventListener("scroll", handleScroll);
        return () => {
            if (chatEl) chatEl.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Creates an interval to smoothly auto-scroll the chat when the bot is typing and the user is already at the bottom.
    useEffect(() => {
        let typingScrollInterval;
        if (isTyping && isUserAtBottom) {
            typingScrollInterval = setInterval(() => {
                if (chatSectionRef.current) {
                    chatSectionRef.current.scrollTo({top: chatSectionRef.current.scrollHeight, behavior: "smooth"});
                }
            }, 100);
        }
        return () => {
            if (typingScrollInterval) clearInterval(typingScrollInterval);
        };
    }, [isTyping, isUserAtBottom]);

    // Adds a new interactive "Redbot" message bubble to the chat queue
    const pushRedbotBubble = (path) => {
        const newMessage = {id: Date.now() + "-redbot", type: "redbot", path, isCompleted: false};
        setMessages((prev) => [...prev, newMessage]);
        setScrollSignal((p) => p + 1);
    };

    // Initiates the Redbot flow based on the user's selected issue.
    const handleRedbotIssueSelection = async (issue) => {
        resetInputModes(); // Reset input state first

        if (!arn) {
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: "Session data is not yet available, please try again shortly.",
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
            return;
        }

        setMessages((prev) => [...prev, {id: Date.now(), type: "user", content: issue}]);
        setRedbotContext({issue});

        try {
            const botRes = await apiBotMessage({arn_id: arn});
            if (botRes?.data) setBotSession(botRes.data.data);

            const issueMapping = {
                "Client Not Found": "client",
                "Transaction Not Found": "trans",
                "Folio Not Found": "folio",
            };
            await apiProblemType({
                arn_id: arn,
                chat_id: botRes.data.data.chat_id,
                chat_date: botRes.data.data.chat_date,
                client_message: issueMapping[issue] || issue,
            });

            if (issue === "Client Not Found") {
                setIsPanMode(true);
                const promptMessage = "Thank you for your selection. Please enter the PAN number.";
                addChatToHistory(issue, promptMessage);
                setMessages((prev) => [
                    ...prev,
                    {
                        id: Date.now(),
                        type: "other",
                        content: promptMessage,
                        shouldAnimate: true,
                        animationDone: false,
                    },
                ]);
                setIsTyping(true);
            } else {
                addChatToHistory(issue, "Please select a registrar.");
                pushRedbotBubble({stage: "select_registrar"});
            }
        } catch (error) {
            console.error("Error starting Redbot flow:", error);
            const errorMessage = "There was an error starting this process. Please try again.";
            addChatToHistory(issue, errorMessage);
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: errorMessage,
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
        }
    };

    // Handles the user's selection of a registrar within the Redbot flow.
    const redbotSelectRegistrar = async (id, registrar) => {
        setMessages((prev) => prev.map((msg) => (msg.id === id ? {...msg, isCompleted: true} : msg)));
        setMessages((prev) => [...prev, {id: Date.now(), type: "user", content: registrar}]);
        const currentContext = {...redbotContext, registrar};
        setRedbotContext(currentContext);
        setScrollSignal((p) => p + 1);

        const {issue} = currentContext;
        const shouldFetchArn =
            (issue === "Transaction Not Found" || issue === "Folio Not Found") &&
            (registrar === "KARVY" || registrar === "CAMS");

        addChatToHistory(`Selected Registrar for "${issue}"`, registrar);
        if (shouldFetchArn) {
            pushRedbotBubble({stage: "select_arn"});
            setArnLoading(true);
            setArnError("");
            try {
                const payload = {
                    arn_id: arn,
                    chat_date: botSession?.chat_date,
                    chat_id: botSession?.chat_id,
                    client_message: registrar,
                    old_chat: 0,
                };
                const {ok, data} = await apiRTA(payload);

                if (ok && data?.status === 1 && Array.isArray(data?.arn_list)) {
                    setArnList(data.arn_list);
                    await apiInsertMessage({
                        arn_id: arn,
                        chat_date: botSession?.chat_date,
                        chat_id: botSession?.chat_id,
                        client_message: "Select ARN from the list",
                        source: 1,
                        chat_stage: 4,
                    });
                } else {
                    setArnError("Unable to fetch ARN list.");
                    addChatToHistory(`ARN Fetch for "${registrar}"`, "Unable to fetch ARN list.");
                    setArnList([]);
                }
            } catch (e) {
                setArnError("Network error while fetching ARN list.");
                addChatToHistory(`ARN Fetch for "${registrar}"`, "Network error while fetching ARN list.");
                setArnList([]);
            } finally {
                setArnLoading(false);
            }
        }
    };

    // Handles the change event when a user selects an ARN from the dropdown.
    const handleArnChange = async (id, arnValue) => {
        if (!arnValue) return;

        setMessages((prev) => prev.map((msg) => (msg.id === id ? {...msg, isCompleted: true} : msg)));
        setMessages((prev) => [...prev, {id: Date.now(), type: "user", content: `Selected ARN: ${arnValue}`}]);
        const currentContext = {...redbotContext, arnId: arnValue};
        setRedbotContext(currentContext);
        setScrollSignal((p) => p + 1);
        addChatToHistory("Selected ARN", arnValue);
        try {
            await apiStoreArn({arn_id: arn, chat_date: botSession?.chat_date, chat_id: botSession?.chat_id});

            await apiInsertMessage({
                arn_id: arn,
                chat_date: botSession?.chat_date,
                chat_id: botSession?.chat_id,
                client_message: arnValue,
                arn_no: arnValue,
                source: 2,
                option_value: arnValue,
                chat_stage: 4,
            });

            const {issue} = currentContext;
            if (issue === "Folio Not Found") {
                const promptMessage =
                    "Okay, please enter the folio number. You can enter multiple folios separated by commas, like this: 1298754/23, 7208454085, ... Maximum 25 folios are allowed";
                addChatToHistory("Next Step for Folio Not Found", promptMessage);
                await apiInsertMessage({
                    arn_id: arn,
                    chat_date: botSession?.chat_date,
                    chat_id: botSession?.chat_id,
                    client_message: promptMessage,
                    source: 1,
                    chat_stage: 5,
                });
                setMessages((prev) => [
                    ...prev,
                    {id: Date.now(), type: "other", content: promptMessage, shouldAnimate: true, animationDone: false},
                ]);
                setIsTyping(true);
                setIsFolioMode(true);
            } else if (issue === "Transaction Not Found") {
                const promptMessage = "Please provide one of the following: Date of Investment or Folio Number.";
                addChatToHistory("Next Step for Transaction Not Found", promptMessage);
                await apiInsertMessage({
                    arn_id: arn,
                    chat_date: botSession?.chat_date,
                    chat_id: botSession?.chat_id,
                    client_message: "1. Date of Investment <br> 2. Folio Number",
                    source: 1,
                    chat_stage: 5,
                });
                pushRedbotBubble({stage: "select_folio_or_date"});
            }
        } catch (e) {
            const errorMessage = "Network error while storing ARN.";
            addChatToHistory("ARN Selection", errorMessage);
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: "Network error while storing ARN.",
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
        }
    };

    // Handles the user's choice between entering a folio number or a date.
    const handlePostArnChoice = async (id, choice) => {
        const choiceText = choice === "folio" ? "Folio Number" : "Date of Investment";

        setMessages((prev) => prev.map((msg) => (msg.id === id ? {...msg, isCompleted: true} : msg)));
        setMessages((prev) => [...prev, {id: Date.now(), type: "user", content: choiceText}]);
        setScrollSignal((p) => p + 1);
        // addChatToHistory("Selected search criteria", choiceText);

        try {
            await apiInsertMessage({
                arn_id: arn,
                chat_date: botSession?.chat_date,
                chat_id: botSession?.chat_id,
                client_message: choiceText,
                source: 2,
                option_value: choice,
                chat_stage: 5,
            });
            if (choice === "folio") {
                const promptMessage =
                    "Okay, please enter the folio number. You can enter multiple folios separated by commas, like this: 1298754/23, 7208454085, ... Maximum 25 folios are allowed";
                addChatToHistory("Folio number selection", promptMessage);
                await apiInsertMessage({
                    arn_id: arn,
                    chat_date: botSession?.chat_date,
                    chat_id: botSession?.chat_id,
                    client_message: promptMessage,
                    source: 1,
                    chat_stage: 6,
                });
                setMessages((prev) => [
                    ...prev,
                    {id: Date.now(), type: "other", content: promptMessage, shouldAnimate: true, animationDone: false},
                ]);
                setIsTyping(true);
                setIsFolioMode(true);
            } else if (choice === "date") {
                addChatToHistory("Date input Selection", "Requesting date input.");
                setIsDateInputMode(true);
            }
        } catch (e) {
            const errorMessage = `Error: ${e.message}`;
            addChatToHistory("Search Criteria Selection", errorMessage);
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: errorMessage,
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
        }
    };

    // Handles the submission of a date from the date input field.
    const handleDateSubmission = async () => {
        if (!dateInputValue) return;

        setMessages((prev) => [...prev, {id: Date.now(), type: "user", content: `Date: ${dateInputValue}`}]);
        setIsDateInputMode(false);
        setIsProcessing(true);

        try {
            const chatDetails = {
                arn_id: arn,
                chat_date: botSession?.chat_date || new Date().toISOString().split("T")[0],
                chat_id: botSession?.chat_id || (arn ? `${arn}_${Date.now()}` : "Undefined"),
            };
            await apiInvestmentDate({...chatDetails, client_message: dateInputValue});
            await apiInsertMessage({
                ...chatDetails,
                client_message: dateInputValue,
                source: 2,
                option_value: dateInputValue,
            });

            const difference = calculateDateDifference(dateInputValue);
            const {data: fileCallResponse} = await apiFileCall({
                ...chatDetails,
                client_message: dateInputValue,
                from_date: dateInputValue,
                difference: difference,
            });

            const messageToShow =
                fileCallResponse?.msg || `Your request for date ${dateInputValue} has been processed.`;

            const questionForHistory = `${redbotContext.issue || "Date Query"} - Date: ${dateInputValue}`;
            addChatToHistory(questionForHistory, messageToShow);
            setMessages((prev) => [
                ...prev,
                {id: Date.now(), type: "other", content: messageToShow, shouldAnimate: true, animationDone: false},
            ]);
            setIsTyping(true);
            // Redirect if status === 1 (flow complete)
            if (fileCallResponse?.status === 1) {
                setTimeout(() => {
                    redirectToHistory();
                }, 600);
            }
        } catch (e) {
            const errorMessage = `There was an error processing the date.`;
            const questionForHistory = `${redbotContext.issue || "Date Query"} - Date: ${dateInputValue}`;
            addChatToHistory(questionForHistory, errorMessage);
            console.error("Error submitting date:", e);
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: `There was an error processing the date.`,
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
        } finally {
            setDateInputValue("");
            setIsProcessing(false);
            setScrollSignal((p) => p + 1);
        }
    };

    // Handles the click event for a prompt suggestion chip.
    const handleSuggestionClick = async (suggestionText) => {
        if (isProcessing || isTyping) return;
        resetInputModes(); // Reset to default input mode
        await sendMessage(suggestionText);
    };

    // Redirects the user to the Freshdesk support page with their ARN.
    const handleOtherQueriesRedirect = () => {
        resetInputModes(); // Reset to default input mode

        if (!arn) {
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    type: "other",
                    content: "Session ARN is not available yet. Please wait a moment and try again.",
                    shouldAnimate: true,
                    animationDone: false,
                },
            ]);
            setIsTyping(true);
            return;
        }

        const url = `${baseUrl}/fresh-desk-support/redirectto-freshdesk?arn_id=${encodeURIComponent(arn)}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    // Handles changes to the main input field, applying validation based on the current mode.
    const handleInputChange = (e) => {
        const value = e.target.value;
        if (isFolioMode) {
            setInputValue(value.replace(/[^0-9/]/g, ""));
        } else if (isPanMode) {
            setInputValue(
                value
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, "")
                .slice(0, 10)
            );
        } else {
            setInputValue(value);
        }
    };

    // Opens the feedback submission modal.
    const openFeedbackModal = () => setIsFeedbackModalOpen(true);

    // Closes the feedback modal and resets its state.
    const closeFeedbackModal = () => {
        setIsFeedbackModalOpen(false);
        setRating(0);
        setReview("");
    };

    // Handles the submission of the user's feedback rating and review.
    const handleSaveFeedback = async () => {
        if (rating === 0) {
            console.error("Please select a star rating before submitting.");
            return;
        }
        setFeedbackSubmitting(true);
        const currentToken = tokenRef.current;
        if (!currentToken) {
            console.error("Authentication token is missing. Please log in again.");
            setFeedbackSubmitting(false);
            return;
        }

        try {
            const response = await fetch(`${AI_AGENT_URL}/save-feedback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${currentToken}`,
                },
                body: JSON.stringify({rating, review}),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({message: "Failed to submit feedback."}));
                throw new Error(errorData.message || "Server error occurred.");
            }

            closeFeedbackModal();
            console.success("Thank you for your feedback!");
        } catch (error) {
            console.error("Error submitting feedback:", error);
        } finally {
            setFeedbackSubmitting(false);
        }
    };

    return (
        <>
            <div className="ai-agent-body">
                <div className="ai-chat-container">
                    <div className="ai-chat-body" ref={chatSectionRef}>
                        <div className="ai-ai-suggestion-top">
                            <div className="ai-ai-header-icon ai-mt-2">
                                <img src={AiGif} width={100} alt="AI Avatar" />
                                <div className="ai-ai-icon-heading ai-align-item-center">
                                    <h5 className="ai-icon-chat-boar" style={{fontWeight: "600", color: "#139185"}}>
                                        <img src={aiLogoModal} alt="Ai-Logo" />
                                    </h5>
                                    <h3>Your AI-powered co-pilot for Wealth Elite is ready </h3>
                                    <h4 className="justify-content-center">
                                        What's on your mind?{" "}
                                        <img src="https://i.ibb.co/S4GMKbMs/wave.png" width={15} alt="Waving Hand" />
                                    </h4>
                                </div>
                            </div>
                            <div className="suggestion-wrapper">
                                <h5 className="suggestion-title">Data Related Queries</h5>
                                <div className="suggestion-chips" style={{marginBottom: "20px"}}>
                                    {REDBOT_ISSUES.map((issue, index) => (
                                        <div
                                            className="chip"
                                            key={index}
                                            onClick={() => handleRedbotIssueSelection(issue)}
                                            style={{cursor: isProcessing || isTyping ? "progress" : "pointer"}}
                                        >
                                            <img src={issuesIcon} alt="icon" className="chip-icon" />
                                            {issue}
                                        </div>
                                    ))}
                                    {isAsm != "1" && (
                                    <div
                                        className="chip"
                                        onClick={handleOtherQueriesRedirect}
                                        style={{cursor: isProcessing || isTyping ? "progress" : "pointer"}}
                                        title="Redirect to Freshdesk support with your ARN"
                                    >
                                        <img src={issuesIcon} alt="icon" className="chip-icon" />
                                        Generate Ticket
                                    </div>
                                    )}
                                </div>

                                <h5 className="suggestion-title">Prompt Suggestions For You</h5>
                                <div className="suggestion-chips">
                                    {promptSuggestions.map((item, index) => (
                                        <div
                                            className="chip"
                                            key={index}
                                            onClick={() => handleSuggestionClick(item.text)}
                                            style={{cursor: isProcessing || isTyping ? "progress" : "pointer"}}
                                        >
                                            <img src={suggestionIcon} alt="icon" className="chip-icon" />
                                            {item.text}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {messages.map((message) => {
                            if (message.type === "system") {
                                return (
                                    <div
                                        key={message.id}
                                        style={{
                                            textAlign: "center",
                                            color: "#888",
                                            margin: "10px 0",
                                            fontSize: "12px",
                                            width: "100%",
                                        }}
                                    >
                                        {message.content}
                                    </div>
                                );
                            }
                            if (message.type === "redbot") {
                                const {path, isCompleted} = message;
                                const inactiveStyle = {pointerEvents: "none", opacity: 0.7};
                                return (
                                    <div key={message.id} className="ai-message ai-other">
                                        <img
                                            src={AiGif}
                                            alt="AI"
                                            style={{width: "32px", height: "32px", borderRadius: "50%"}}
                                        />
                                        <div
                                            className="ai-bubble redbot-bubble"
                                            style={{textAlign: "left", minWidth: "23px"}}
                                        >
                                            {path.stage === "select_registrar" && (
                                                <>
                                                    <div className="redbot-header">Select registrar</div>
                                                    <div className="redbot-buttons">
                                                        {REGISTRARS.map((r) => (
                                                            <button
                                                                key={r}
                                                                className="chip registrar text-white"
                                                                style={isCompleted ? inactiveStyle : {}}
                                                                onClick={() => redbotSelectRegistrar(message.id, r)}
                                                            >
                                                                {r}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                            {path.stage === "select_arn" && (
                                                <div className="redbot-arn">
                                                    <div className="redbot-header">Select ARN</div>
                                                    <div
                                                        className="custom-dropdown"
                                                        style={isCompleted ? inactiveStyle : {}}
                                                    >
                                                        <select
                                                            className="redbot-select"
                                                            defaultValue=""
                                                            onChange={(e) =>
                                                                handleArnChange(message.id, e.target.value)
                                                            }
                                                        >
                                                            <option value="" disabled>
                                                                {arnLoading
                                                                    ? "Loading..."
                                                                    : (arnList?.length || 0) === 0
                                                                    ? "No ARN available"
                                                                    : "Select ARN ID"}
                                                            </option>
                                                            {arnList.map((opt) => (
                                                                <option key={opt} value={opt}>
                                                                    {opt}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {arnError && (
                                                        <div
                                                            className="redbot-selection"
                                                            style={{marginTop: 6, color: "crimson"}}
                                                        >
                                                            {arnError}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {path.stage === "select_folio_or_date" && (
                                                <div className="redbot-next-step">
                                                    <div className="redbot-header">
                                                        Please provide one of the following:
                                                    </div>
                                                    <div className="redbot-buttons">
                                                        <button
                                                            className="chip registrar text-white"
                                                            style={
                                                                isCompleted
                                                                    ? inactiveStyle
                                                                    : {color: "white", backgroundColor: "#062F87"}
                                                            }
                                                            onClick={() => handlePostArnChoice(message.id, "date")}
                                                        >
                                                            Date of Investment
                                                        </button>
                                                        <button
                                                            className="chip registrar text-white"
                                                            style={
                                                                isCompleted
                                                                    ? inactiveStyle
                                                                    : {color: "white", backgroundColor: "#062F87"}
                                                            }
                                                            onClick={() => handlePostArnChoice(message.id, "folio")}
                                                        >
                                                            Folio Number
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div
                                    key={message.id}
                                    className={`ai-message ${message.type === "user" ? "ai-user" : "ai-other"}`}
                                >
                                    {message.type === "other" && (
                                        <img
                                            src={AiGif}
                                            alt="AI"
                                            style={{width: "32px", height: "32px", borderRadius: "50%"}}
                                        />
                                    )}
                                    {message.type === "user" && (
                                        <img
                                            src={AiLogo}
                                            alt="User"
                                            style={{width: "38px", height: "38px", borderRadius: "50%"}}
                                        />
                                    )}
                                    <div className="ai-bubble" style={{textAlign: "left", minWidth: "23px"}}>
                                        {message.isLoading ? (
                                            <div className="ai-wave-loading-bubble">
                                                <span className="ai-wave-dot" style={{"--delay": "0s"}} />
                                                <span className="ai-wave-dot" style={{"--delay": "0.2s"}} />
                                                <span className="ai-wave-dot" style={{"--delay": "0.4s"}} />
                                            </div>
                                        ) : message.type === "other" && message.shouldAnimate ? (
                                            <TypeAnimation
                                                sequence={[
                                                    String(message.content).replace(/<br\s*\/?>/gi, "\n"),
                                                    () => handleAnimationEnd(message.id),
                                                ]}
                                                wrapper="span"
                                                cursor={false}
                                                repeat={0}
                                                speed={80}
                                                style={{whiteSpace: "pre-wrap"}}
                                            />
                                        ) : (
                                            message && (
                                                <>
                                                    {" "}
                                                    {String(message.content)
                                                    .split("\n")
                                                    .map((line, i, arr) => (
                                                        <React.Fragment key={i}>
                                                            {line}
                                                            {i < arr.length - 1 && <br />}
                                                        </React.Fragment>
                                                    ))}{" "}
                                                </>
                                            )
                                        )}
                                        {message.type === "other" && message.animationDone && message.backendMessageId && (
                                            <div style={{display: "inline-block", marginLeft: "10px"}}>
                                                <FaThumbsUp
                                                    style={{
                                                        color: message.liked ? "lightseagreen" : "#666",
                                                        cursor: "pointer",
                                                        pointerEvents: "auto",
                                                    }}
                                                    onClick={() => {
                                                        if (message.liked) {
                                                            handleUndoFeedback(message.id);
                                                        } else {
                                                            if (message.disliked) handleUndoFeedback(message.id);
                                                            handleFeedback(message.id, "like");
                                                        }
                                                    }}
                                                />
                                                <FaThumbsDown
                                                    style={{
                                                        color: message.disliked ? "red" : "#666",
                                                        cursor: "pointer",
                                                        marginLeft: "10px",
                                                        pointerEvents: "auto",
                                                    }}
                                                    onClick={() => {
                                                        if (message.disliked) {
                                                            handleUndoFeedback(message.id);
                                                        } else {
                                                            if (message.liked) handleUndoFeedback(message.id);
                                                            handleFeedback(message.id, "dislike");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        {transcript && (
                            <div className="ai-message ai-user">
                                {" "}
                                <img src={AiLogo} alt="User Avatar" />{" "}
                                <div className="ai-bubble ai-listening-transcript">{transcript}</div>{" "}
                            </div>
                        )}
                        {(status || error) && (
                            <div className="ai-message ai-other ai-status-message">
                                {" "}
                                <img src={AiGif} alt="AI Avatar" /> <div className="ai-bubble">{status || error}</div>{" "}
                            </div>
                        )}
                    </div>
                    <div className="ai-chat-footer">
                        <div className="aiiiiiiiii" style={{display: "flex", alignItems: "center", gap: "8px"}}>
                            {/* <div className="ai-new-tab-create">
                                <Tooltip title="New Chat" arrow>
                                    <abbr>
                                        <img src={newtabicon} alt="New Tabs Icon" onClick={handleNewChatClick} />
                                    </abbr>
                                </Tooltip>
                            </div> */}
                            <div
                                style={{
                                    position: "relative",
                                    display: "inline-block",
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                <img
                                    src={likeaibtn}
                                    className="rateusIcon"
                                    onClick={openFeedbackModal}
                                    alt="Rate Us"
                                    style={{
                                        cursor: "pointer",
                                        transition: "transform 0.2s ease",
                                        transform: isHovered ? "scale(1.1)" : "scale(1)",
                                    }}
                                />
                                {isHovered && (
                                    <div className="rateus-container">
                                        Rate Us
                                        <div className="rateus-arrow"></div>
                                    </div>
                                )}
                            </div>

                            <div style={{flex: 1, display: "flex", alignItems: "center"}}>
                                {isDateInputMode ? (
                                    <div className="date-input-container" style={{width: "100%", display: "flex"}}>
                                        <input
                                            type="date"
                                            className="date-input-footer"
                                            value={dateInputValue}
                                            onChange={(e) => setDateInputValue(e.target.value)}
                                            style={{width: "100%"}}
                                        />
                                        <button className="date-submit-btn" onClick={handleDateSubmission}>
                                            ➤
                                        </button>
                                    </div>
                                ) : (
                                    <div
                                        className="send-aii-main-btn"
                                        style={{
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder={inputPlaceholder}
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            onKeyPress={handleKeyPress}
                                            className="sendInputAi"
                                        />
                                        <button
                                            onClick={() => sendMessage()}
                                            disabled={isProcessing || isTyping || !inputValue.trim()}
                                            className={`sendBtnAi ${isProcessing || isTyping || !inputValue.trim() ? "disabled" : "active"}`}>
                                            <img
                                                src={sendaiiimg}
                                                alt="Send Img"
                                                style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    opacity: isProcessing || isTyping || !inputValue.trim() ? 0.5 : 1,
                                                }}
                                            />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Feedback Modal */}
            {isFeedbackModalOpen && (
            <div className="feedback-modal-overlay">
                <div className="feedback-modal">
                    <button className="close-btn" onClick={closeFeedbackModal}>
                    &times;
                    </button>

                    <h2>Rate your experience</h2>
                    <p>We highly value your feedback. Please rate your experience with us.</p>
            
                    <div className="ai-like-smoji">
                    <ul className="ai-chat-image-animation">
                        {[ratesmile2, ratesmile3, ratesmile4, ratesmile5, ratesmile1].map(
                        (emoji, index) => {
                            const ratingValue = index + 1;
                            const labels = ["Terrible", "Poor", "Fair", "Excellent", "Outstanding"];
                            return (
                            <li key={ratingValue}>
                                <button
                                type="button"
                                className={`emoji-btn ${rating === ratingValue ? "active" : ""}`}
                                onClick={() => {
                                    if (rating === ratingValue) {
                                    setRating(0);
                                    } else {
                                    setRating(ratingValue);
                                    }
                                }}
                                >
                                <img src={emoji} alt={`emoji-${ratingValue}`} />
                                <span className="tooltip">{labels[index]}</span>
                                </button>
                            </li>
                            );
                        }
                        )}
                    </ul>
                    </div>
                <textarea
                placeholder="Tell us about your experience!"
                value={review}
                onChange={(e) => setReview(e.target.value)}
                />
                <button
                className="send-btn"
                onClick={handleSaveFeedback}
                disabled={feedbackSubmitting || rating === 0}
                >
                {feedbackSubmitting ? "Submitting..." : "Submit"}
                </button>
    </div>
    </div>
    )}
    </>
    );
};

export default AiAgent1;
